var _defs, _rect, _rect2, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "601d7c838f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 132 75.148438 L 243 75.148438 L 243 192 L 132 192 Z M 132 75.148438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4080dfcf1b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 85.121094 192 L 289.871094 192 L 289.871094 300 L 85.121094 300 Z M 85.121094 192 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#49aa27",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#601d7c838f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 187.496094 191.703125 C 217.574219 191.703125 242.042969 159.777344 242.042969 129.699219 C 242.042969 99.625 217.574219 75.148438 187.496094 75.148438 C 157.417969 75.148438 132.949219 99.625 132.949219 129.699219 C 132.953125 159.773438 157.417969 191.703125 187.496094 191.703125 Z M 187.496094 191.703125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4080dfcf1b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 228.445312 192.261719 C 217.863281 200.324219 204.664062 205.117188 190.367188 205.117188 L 184.625 205.117188 C 170.324219 205.117188 157.121094 200.320312 146.542969 192.261719 C 111.996094 197.847656 85.613281 227.789062 85.613281 263.910156 C 85.613281 283.753906 131.226562 299.84375 187.496094 299.84375 C 243.761719 299.84375 289.378906 283.753906 289.378906 263.910156 C 289.378906 227.789062 262.992188 197.847656 228.445312 192.261719 Z M 228.445312 192.261719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.e645a6043ad4f881776866e0b610e03f.svg";
export { ForwardRef as ReactComponent };